import TrackerManagementTrackerListSlice from '../../slices/experiences/TrackerManagementTrackerListSlice'
import TRACKER_MANAGEMENT_EXPERIENCE_TYPES from '../../types/experiences/TrackerManagement'
import { makeActionCreator } from '../../../modules/utilities/store'
import TrackerManagementTrackerPositionsSlice from '../../slices/experiences/TrackerManagementTrackerPositionsSlice'
import TrackerManagementTrackerListExportSlice from '../../slices/experiences/TrackerManagementTrackerListExportSlice'
import TrackerManagementTrackerPositionsExportSlice
  from '../../slices/experiences/TrackerManagementTrackerPositionsExportSlice'
import TrackerManagementTrackerActivityLogsSlice from '../../slices/experiences/TrackerManagementTrackerActivityLogsSlice'

const TrackerManagementExperienceActions = {
  list: TrackerManagementTrackerListSlice.actions,
  listExport: TrackerManagementTrackerListExportSlice.actions,
  /**
   * @param trackerItem {StoreDevice}: StoreDevice instance containing edited tracker data.
   * @param onSuccess {function}: executed if creation was successful.
   * @returns {{ type: string, data: { trackerItem: StoreDevice, onSuccess: function } }}
   */
  create: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.CREATE, 'trackerItem', 'onSuccess'),
  /**
   * Fetches the full tracker (inputs, outputs, attribute values, coordinates) by id via
   * GET /tracker/:id and normalizes it into the data stores. Used by the edit screen, since the
   * trackers grid list returns only lightweight rows.
   * @param trackerId {string}: id of the tracker to hydrate.
   * @returns {{ type: string, data: { trackerId: string } }}
   */
  fetchDetails: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.FETCH_DETAILS, 'trackerId'),
  /**
   * @param trackerItem {StoreDevice}: StoreDevice instance containing edited tracker data.
   * @param onSuccess {function}: executed if editing was successful.
   * @returns {{ type: string, data: { trackerItem: StoreDevice, onSuccess: function } }}
   */
  edit: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.EDIT, 'trackerItem', 'onSuccess'),
  /**
   * @param trackerId {string}: id of tracker to delete.
   * @returns {{ type: string, data: { trackerId: string } }}
   */
  delete: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.DELETE, 'trackerId'),
  trackerPositions: TrackerManagementTrackerPositionsSlice.actions,
  trackerPositionsExport: TrackerManagementTrackerPositionsExportSlice.actions,
  activityLogs: TrackerManagementTrackerActivityLogsSlice.actions,
  /**
   * @param trackerId {string}: ID of tracker the control panel is opened for.
   * @returns {{ type: string, data: { trackerId: string } }}
   */
  openTrackerControlPanel: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.OPEN_TRACKER_CONTROL_PANEL, 'trackerId'),
  /**
   * @param trackerId {string}: Id of tracker the control panel is hidden for.
   * @returns {{ type: string, data: { trackerId: string } }}
   */
  closeTrackerControlPanel: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.CLOSE_TRACKER_CONTROL_PANEL, 'trackerId'),
  /**
   * @param trackerId {string}: Id of tracker the output is sent to.
   * @param trackerOutputId {string}: Id of the activated(sent) tracker output.
   * @returns {{ type: string, data: { trackerId: string, trackerOutputId: string } }}
   */
  sendOutputToTracker: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.SEND_OUTPUT_TO_TRACKER, 'trackerId', 'trackerOutputId'),
  /**
   * @param trackerId {string}: Id of the listened tracker.
   * @param listeningPhoneNumber {string}: Phone number on which the tracker can be listened.
   * @returns {{ type: string, data: { trackerId: string, listeningPhoneNumber: string } }}
   */
  listenTracker: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.LISTEN, 'trackerId', 'listeningPhoneNumber'),
  /**
   * @param trackerId {string}: Id of the updated tracker.
   * @param isActive {boolean}: Updated value of the "isActive" attribute.
   * @returns {{ type: string, data: { trackerId: string, isActive: boolean } }}
   */
  updateAttributeActive: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.UPDATE_ATTRIBUTE_ACTIVE, 'trackerId', 'isActive'),
  /**
   * @param trackerId {string}: Id of the tracker the user will be detached from.
   * @returns {{ type: string, data: { trackerId: string } }}
   */
  detachUser: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.DETACH_USER, 'trackerId'),
  /**
   * @param trackerId {string}: Id of the tracker the command will be sent to.
   * @param command {string}: Sent command.
   * @returns {{ type: string, data: { trackerId: string, command: string } }}
   */
  sendCommand: makeActionCreator(TRACKER_MANAGEMENT_EXPERIENCE_TYPES.SEND_COMMAND, 'trackerId', 'command'),
  /**
   * @param deviceCoordinateId {string}: id of the device coordinate the location string will be fetched for.
   * @returns {{ type: string, data: { deviceCoordinateId: string } }}
   */
  fetchLocationStringForCoordinate: makeActionCreator(
    TRACKER_MANAGEMENT_EXPERIENCE_TYPES.FETCH_LOCATION_STRING_FOR_COORDINATE,
    'deviceCoordinateId'
  )
}

export default TrackerManagementExperienceActions

